import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import {
  CompanyComment,
  CreateOrUpdateCompanyCommentRequest,
  HttpResponse,
} from "@/types";

export function useUpdateCompanyComment() {
  const currentCompanyId = useCurrentCompanyId();

  const mutation = useMutation({
    mutationFn: async ({
      companyCommentId,
      updateCompanyCommentRequest,
    }: {
      companyCommentId: number;
      updateCompanyCommentRequest: CreateOrUpdateCompanyCommentRequest;
    }) => {
      const path = `companies/${currentCompanyId}/company-comments/${companyCommentId.toString()}`;
      const res = await guacHttpClient.patch<
        CompanyComment,
        HttpResponse<CompanyComment>,
        CreateOrUpdateCompanyCommentRequest
      >(path, updateCompanyCommentRequest);

      return res.data;
    },
  });

  return mutation;
}
